<template>
  <div class="animated fadeIn">
    <div class="card card-blue">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive">
              <table class="table table-sm table-bordered table-striped table-hover table-logoped">
                <thead>
                  <tr>
                    <th>
                      <sortingcolumn v-model="pagination" field="name" v-on:reload="getData">{{$t('NAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="surname" v-on:reload="getData">{{$t('SURNAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="contactNumber" v-on:reload="getData">{{$t('CONTACTNUMBER')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="email" v-on:reload="getData">{{$t('EMAIL')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="educationalGroupId" v-on:reload="getData">{{$t('EDUCATIONALGROUP')}}</sortingcolumn>
                    </th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in response.root">
                    <tr :key="item.educatorId" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{item.name}}</td>
                      <td>{{item.surname}}</td>
                      <td>{{item.contactNumber}}</td>
                      <td>{{item.email}}</td>
                      <td>{{item.educationalName}}</td>
                      <td>
                        <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.educatorId)">{{$t('DELETE')}}</button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <pagination
                  v-bind:totalCount="response.totalCount"
                  v-model="pagination"
                  v-on:reload="getData"></pagination>
              </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('EDUCATORFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <educatorform v-bind:formData="formData"
          v-bind:formError="formError"
          v-bind:educationalGroup="educationalGroup"></educatorform>
      </div>
      <div class="text-right">
        <b-btn class="button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/api/educator/Educator';
import EducationalApi from '@/api/educational_group/EducationalGroup';
import EducatorForm from './Form.vue';

export default
{
    name: 'Educator',
    components:
  {
      educatorform: EducatorForm,
  },
    data()
    {
        return {
            response:
      {},
            educationalGroup: {},
            formError:
      {},
            formData:
      {
          name: '',
          surname: '',
          contactNumber: '',
          email: '',
          educationalGroupId: null,
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getEducationalGroup();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getEducationalGroup()
      {
          const me = this;
          try
          {
              const data = await EducationalApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.educationalGroup = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.educatorId !== 'undefined')
              {
                  item.id = item.educatorId;
                  delete (item.educatorId);
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              contactNumber: '',
              email: '',
              educationalGroupId: null,
          };
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getData();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
